// The school name from a LINK_REPLACED error, or null for any other error.
export function linkReplacedSchoolName(error: unknown): string | null {
  const errors = (error as { graphQLErrors?: { extensions?: Record<string, unknown> }[] } | null)?.graphQLErrors;
  const replaced = errors?.find((e) => e.extensions?.code === 'LINK_REPLACED');
  if (!replaced) return null;
  return String(replaced.extensions?.schoolName ?? 'The school');
}
